// extracted by mini-css-extract-plugin
export default {"amountValue":"a2t6r","roundButton":"b2t6r","value":"c2t6r","external":"d2t6r","valueFontSize":"e2t6r","valueWidth":"f2t6r"};